import download from "downloadjs";
import { useGet } from "../../../../api/useCall";
import type { Input } from "../../../../api/call";

type ExportInput = Input<"GET", "/projects/:projectId(uuid)/setups/:setupId(uuid)/export/artifact">;
export type SetupExportSection = ExportInput["query"]["section"];

// Menu overlays unmount when closed; keep the request lock across reopenings.
const pendingExports = new Set<string>();

export default function useExportSetupArtifact(
  projectId: string,
  setupId: string,
  section: SetupExportSection,
) {
  const request = useGet("/projects/:projectId(uuid)/setups/:setupId(uuid)/export/artifact");
  const requestKey = `${projectId}/${setupId}/${section}`;
  const exportArtifact = async () => {
    if (pendingExports.has(requestKey)) return;
    pendingExports.add(requestKey);
    try {
      const response = await request({ routeParams: { projectId, setupId }, query: { section } });
      download(response.body as unknown as Blob, response.headers.filename);
    } finally {
      pendingExports.delete(requestKey);
    }
  };
  return { exportArtifact, loading: request.loading };
}
